import { render, staticRenderFns } from "./SubmissionSession.vue?vue&type=template&id=3a0599a0&scoped=true&"
import script from "./SubmissionSession.vue?vue&type=script&lang=js&"
export * from "./SubmissionSession.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionSession.vue?vue&type=style&index=0&id=3a0599a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0599a0",
  null
  
)

export default component.exports